// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { getProfile, getAddress, getSuccess } from
'../../account/components/AccountTab/components/MyProfile/store/selectors';
import * as profileActions from
'../../account/components/AccountTab/components/MyProfile/store/actions';
import history from '../../../services/history';
import { DataContainer } from '../components';
import PaperLayout from '../../../components/PaperLayout/PaperLayout';
import { BasketTotal, Button } from '../../../components';
import { getTotal } from '../../basket/store/selectors';
import styles from './styles';
import { getPrice } from '../../../services/priceHelper';
import { getActiveDiscountCode } from '../../get-paid/store/selectors';

class CheckoutPage extends React.Component {
  state = { };

  componentDidMount() {
    const id = localStorage.getItem('loggedID');
    const token = localStorage.getItem('token');
    this.props.requestAddress(id, token);
    this.props.requestProfile(id, token);
  }

  onConfirm = () => {
    const { profile } = this.props;
    const id = localStorage.getItem('loggedID');
    const token = localStorage.getItem('token');
    const to = history.location.state ? history.location.state.to : '/get-paid';
    this.props.requestProfileEdit(profile, id, token, { page: 'checkout' }, to);
  }

  render() {
    const { total, classes, activeDiscountCode } = this.props;

    let needItem = 10;
    let needMoney = 10;
    needMoney = 10 - total.price;
    needMoney = parseFloat(needMoney.toFixed(2));
    needItem = 10 - total.items;
    const isAll = needMoney <= 0 || needItem <= 0;

    return (
      <PaperLayout hasSubPaper={false} label={'CHECKOUT'}>
        <div className={classes.mainContainer}>
          <div className={classes.basketTotalContainer}>
            <BasketTotal
              price={getPrice(activeDiscountCode, total)}
              items={total.items}
              isAll={isAll}
              activeDiscountCode={activeDiscountCode}
            />
          </div>
          <DataContainer
            profile={this.props.profile}
            address={this.props.address}
            changeField={this.props.changeField}
            changeFieldAddress={this.props.changeFieldAddress}
            requestProfileEdit={this.props.requestProfileEdit}
          />
          <h6 className={classNames(classes.successText,
            !this.props.success.status ? classes.rejectedColor : '')}
          >
            {this.props.success.checkout}
          </h6>
          <Button
            style={classes.button}
            onPress={this.onConfirm}
            text={'NEXT'}
          />
        </div>
      </PaperLayout>
    );
  }
}

CheckoutPage.propTypes = {
  classes: PropTypes.object,
  total: PropTypes.object,
  requestAddress: PropTypes.func,
  requestProfile: PropTypes.func,
  address: PropTypes.object,
  profile: PropTypes.object,
  requestProfileEdit: PropTypes.func,
  changeField: PropTypes.func,
  changeFieldAddress: PropTypes.func,
  success: PropTypes.object,
  activeDiscountCode: PropTypes.object,
};
CheckoutPage.defaultProps = {
  classes: {},
  address: {},
  profile: {},
  total: {
    price: 0,
    items: 0,
  },
  requestAddress: () => { },
  requestProfile: () => { },
  requestProfileEdit: () => { },
  changeField: () => { },
  changeFieldAddress: () => { },
  success: {},
  activeDiscountCode: {},
};

const mapStateToProps = (state) => {
  return {
    address: getAddress(state),
    profile: getProfile(state),
    total: getTotal(state),
    success: getSuccess(state),
    activeDiscountCode: getActiveDiscountCode(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeField: (value, name) => dispatch(profileActions.changeField(value, name)),
    changeFieldAddress: (value, name) => dispatch(profileActions.changeFieldAddress(value, name)),
    requestProfile: (id, token) => dispatch(profileActions.requestProfile(id, token)),
    requestProfileEdit: (data, id, token, page, to) => dispatch(profileActions
      .requestProfileEdit(data, id, token, page, to)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(CheckoutPage));
